// For New template js
(function () {
  'use strict';

  const qs  = (sel, ctx = document) => ctx.querySelector(sel);
  const qsa = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const $   = (id) => document.getElementById(id);
  const isMobile = () => window.innerWidth <= 950;

  const money = (cents) => {
    return window.Shopify?.currency?.active
      ? new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify.currency.active }).format(cents / 100)
      : `$${(cents / 100).toFixed(2)}`;
  };

  document.querySelectorAll('[data-section-type="new-main-pdp"]').forEach(initPDP);

  function initPDP(section) {
    const sid = section.dataset.sectionId;

    const jsonEl = $(`pdp-product-json-${sid}`);
    if (!jsonEl) return;
    let productData;
    try { productData = JSON.parse(jsonEl.textContent); }
    catch (e) { console.error('[PDP] JSON parse error', e); return; }

    const media = {
      items: qsa('.pdp-media-item', section),
      thumbs: qsa('.pdp-thumb', section),
      refresh() {
        this.items  = qsa('.pdp-media-item', section);
        this.thumbs = qsa('.pdp-thumb', section);
      }
    };
    // Keep legacy aliases so existing code below still works unchanged
    const mediaItems   = media.items;   // initial ref only — use media.items after swaps
    const thumbButtons = media.thumbs;  // same
    const thumbStrip     = $(`pdp-thumbnails-${sid}`);
    const mainMediaWrap  = $(`pdp-main-media-${sid}`);
    const overlayEl      = $(`pdp-overlay-${sid}`);
    const overlayStage   = $(`pdp-overlay-stage-${sid}`);
    const overlayClose   = $(`pdp-overlay-close-${sid}`);
    const overlayPrev    = $(`pdp-overlay-prev-${sid}`);
    const overlayNext    = $(`pdp-overlay-next-${sid}`);
    const variantIdInput = $(`pdp-variant-id-${sid}`);

    let currentOverlayIndex = 0;
    let overlaySlides       = [];
    let activeThumbIndex    = 0;
    let currentMode         = isMobile() ? 'mobile' : 'desktop';

    // Detect which option index is the color option
    // function getColorOptionIndex() {
    //   if (!productData.variants.length) return -1;
    //   // Try to find it from section DOM option headers
    //   let colorIdx = -1;
    //   qsa('.pdp-option', section).forEach((g, i) => {
    //     const name = (g.querySelector('.pdp-option__name') || {}).textContent || '';
    //     if (/colou?r/i.test(name)) colorIdx = i;
    //   });
    //   return colorIdx;
    // }
    function getColorOptionIndex() {
      return productData.variants.length ? 0 : -1;
    }

    // Lock flag: prevents scroll-spy from overriding thumbnail clicks
    let isScrollingToMedia  = false;
    let scrollLockTimer     = null;

    /* ─────────────────────────────────────────────
       STICKY HEADER HEIGHT
    ───────────────────────────────────────────── */
    function getStickyHeaderHeight() {
      let h = 0;
      document.querySelectorAll('header,[data-sticky],.sticky-header,#shopify-section-header').forEach(el => {
        const s = getComputedStyle(el);
        if (s.position === 'sticky' || s.position === 'fixed') h = Math.max(h, el.offsetHeight);
      });
      return h;
    }

    /* ─────────────────────────────────────────────
       TEARDOWN DESKTOP
    ───────────────────────────────────────────── */
    function teardownDesktop() {
      const infoCol = section.querySelector('.pdp-info-column');
      if (infoCol) { infoCol.style.position = ''; infoCol.style.top = ''; }
      window.removeEventListener('scroll', desktopStickyScroll);
    }

    /* ─────────────────────────────────────────────
       TEARDOWN MOBILE
    ───────────────────────────────────────────── */
    function teardownMobile() {
      const dotsWrap = section.querySelector(`.pdp-mobile-dots-${sid}`);
      if (dotsWrap) dotsWrap.style.display = 'none';

      const wrapParent = mainMediaWrap ? mainMediaWrap.parentNode : null;
      if (wrapParent) {
        const ap = wrapParent.querySelector(`.pdp-mob-arrow-prev-${sid}`);
        const an = wrapParent.querySelector(`.pdp-mob-arrow-next-${sid}`);
        if (ap) ap.style.display = 'none';
        if (an) an.style.display = 'none';
      }

      const mediaCol = section.querySelector('.pdp-media-column');
      if (mediaCol) mediaCol.style.cssText = '';
      if (mainMediaWrap) mainMediaWrap.style.cssText = '';
      if (thumbStrip) thumbStrip.style.display = '';
    }

    /* ─────────────────────────────────────────────
       MOBILE CAROUSEL
    ───────────────────────────────────────────── */
    function setupMobileCarousel() {
      if (!mainMediaWrap) return;

      if (thumbStrip) thumbStrip.style.display = 'none';

      const mediaCol = section.querySelector('.pdp-media-column');
      if (mediaCol) mediaCol.style.cssText = 'display:block;';

      mainMediaWrap.style.cssText = 'display:flex;flex-direction:row;overflow-x:scroll;scroll-snap-type:x mandatory;scroll-behavior:smooth;gap:0;-ms-overflow-style:none;scrollbar-width:none;-webkit-overflow-scrolling:touch;position:relative;';

      const styleId = `pdp-m-style-${sid}`;
      if (!document.getElementById(styleId)) {
        const s = document.createElement('style');
        s.id = styleId;
        s.textContent = `#pdp-main-media-${sid}::-webkit-scrollbar{display:none}#pdp-main-media-${sid} .pdp-media-item{flex:0 0 100%;width:100%;scroll-snap-align:start;border-radius:0;}`;
        document.head.appendChild(s);
      }

      // Dots
      let dotsWrap = section.querySelector(`.pdp-mobile-dots-${sid}`);
      if (!dotsWrap) {
        dotsWrap = document.createElement('div');
        dotsWrap.className = `pdp-mobile-dots-${sid}`;
        mainMediaWrap.parentNode.insertBefore(dotsWrap, mainMediaWrap.nextSibling);
      }
      dotsWrap.style.cssText = 'display:flex;justify-content:center;align-items:center;gap:6px;padding:10px 0 2px;';
      dotsWrap.innerHTML = '';
      media.items.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.style.cssText = `width:6px;height:6px;border-radius:50%;border:none;padding:0;cursor:pointer;flex-shrink:0;transition:background .2s,transform .2s;background:${i === 0 ? '#111' : 'rgba(0,0,0,0.25)'};transform:${i === 0 ? 'scale(1.4)' : 'scale(1)'};`;
        dot.setAttribute('aria-label', `Go to image ${i + 1}`);
        dot.addEventListener('click', () => scrollToCarouselItem(i));
        dotsWrap.appendChild(dot);
      });

      // Arrows
      const wrapParent = mainMediaWrap.parentNode;
      wrapParent.style.position = 'relative';

      const arrowBase = 'position:absolute;top:45%;transform:translateY(-50%);width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,0.9);border:none;align-items:center;justify-content:center;cursor:pointer;z-index:3;box-shadow:0 1px 4px rgba(0,0,0,.18);';

      let arrowPrev = wrapParent.querySelector(`.pdp-mob-arrow-prev-${sid}`);
      if (!arrowPrev) {
        arrowPrev = document.createElement('button');
        arrowPrev.className = `pdp-mob-arrow-prev-${sid}`;
        arrowPrev.type = 'button';
        arrowPrev.setAttribute('aria-label', 'Previous image');
        arrowPrev.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>`;
        arrowPrev.addEventListener('click', () => scrollToCarouselItem(activeThumbIndex - 1));
        wrapParent.appendChild(arrowPrev);
      }
      arrowPrev.style.cssText = arrowBase + 'left:10px;display:none;';

      let arrowNext = wrapParent.querySelector(`.pdp-mob-arrow-next-${sid}`);
      if (!arrowNext) {
        arrowNext = document.createElement('button');
        arrowNext.className = `pdp-mob-arrow-next-${sid}`;
        arrowNext.type = 'button';
        arrowNext.setAttribute('aria-label', 'Next image');
        arrowNext.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>`;
        arrowNext.addEventListener('click', () => scrollToCarouselItem(activeThumbIndex + 1));
        wrapParent.appendChild(arrowNext);
      }
      arrowNext.style.cssText = arrowBase + `right:10px;display:${media.items.length > 1 ? 'flex' : 'none'};`;

      function updateMobileArrows(idx) {
        arrowPrev.style.display = idx <= 0 ? 'none' : 'flex';
        arrowNext.style.display = idx >= media.items.length - 1 ? 'none' : 'flex';
      }

      const carouselObs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const idx = parseInt(entry.target.dataset.index, 10);
            activeThumbIndex = idx;
            updateMobileDots(idx);
            updateMobileArrows(idx);
          }
        });
      }, { root: mainMediaWrap, threshold: 0.5 });
      media.items.forEach(item => carouselObs.observe(item));
    }

    function scrollToCarouselItem(index) {
      if (!mainMediaWrap) return;
      index = Math.max(0, Math.min(media.items.length - 1, index));
      const target = media.items[index];
      if (!target) return;
      mainMediaWrap.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      activeThumbIndex = index;
    }

    function updateMobileDots(index) {
      const dotsWrap = section.querySelector(`.pdp-mobile-dots-${sid}`);
      if (!dotsWrap) return;
      qsa('button', dotsWrap).forEach((dot, i) => {
        dot.style.background = i === index ? '#111' : 'rgba(0,0,0,0.25)';
        dot.style.transform  = i === index ? 'scale(1.4)' : 'scale(1)';
      });
    }

    /* ─────────────────────────────────────────────
       METAFIELD MEDIA SWAP
       Swaps gallery images when color changes.
       Falls back to default product media if no
       feature_images exist for this color.
    ───────────────────────────────────────────── */
    // Snapshot TRUE defaults from productData (not DOM, which may already show feature images)
    const defaultThumbsHTML = (() => {
      let html = '';
      productData.media.forEach((m, i) => {
        const src = m.preview_src || '';
        const alt = m.alt || '';
        html += `<button class="pdp-thumb${i === 0 ? ' is-active' : ''}" data-media-id="${m.id}" data-index="${i}" aria-label="View media ${i + 1}" type="button"><img src="${src}" alt="${alt}" loading="lazy" width="120" height="120"></button>`;
      });
      return html;
    })();

    const defaultMediaItemsHTML = (() => {
      return productData.media.map((m, i) => {
        if (m.media_type === 'image') {
          return `<button class="pdp-media-item__trigger" type="button" aria-label="Enlarge image" data-open-overlay="${i}"><img src="${m.full_src || m.preview_src}" srcset="${m.preview_src} 600w, ${m.full_src || m.preview_src} 1400w" sizes="(max-width: 768px) 100vw, 60vw" alt="${m.alt || ''}" loading="lazy" class="pdp-media-item__img"><span class="pdp-media-item__zoom-hint"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg></span></button>`;
        }
        // For video/model fall back to whatever is in the DOM for that media id
        const domItem = qs(`[data-media-id="${m.id}"]`, section);
        return domItem ? domItem.innerHTML : '';
      });
    })();

    const defaultOverlayData = productData.media.map(m => ({ ...m }));

    function getFeatureImagesForColor(colorValue) {
      // Find the first variant whose color option matches colorValue
      const colorIdx = getColorOptionIndex();
      if (colorIdx < 0) return null;
      const match = productData.variants.find(v => {
        return (v.options[colorIdx] || '').toLowerCase() === colorValue.toLowerCase();
      });
      if (!match || !match.feature_images || !match.feature_images.length) return null;
      return match.feature_images;
    }

    function swapMediaForColor(colorValue) {
      const images = getFeatureImagesForColor(colorValue);

      // --- REBUILD THUMBNAILS ---
      if (thumbStrip) {
        thumbStrip.innerHTML = '';
        if (images && images.length) {
          images.forEach((img, i) => {
            const btn = document.createElement('button');
            btn.className       = 'pdp-thumb' + (i === 0 ? ' is-active' : '');
            btn.dataset.mediaId = 'meta_' + i;
            btn.dataset.index   = String(i);
            btn.type            = 'button';
            btn.setAttribute('aria-label', `View media ${i + 1}`);
            btn.innerHTML       = `<img src="${img.src_600 || img.src}" alt="${img.alt || ''}" loading="lazy" width="120" height="120">`;
            thumbStrip.appendChild(btn);
          });
        // } else {
        //   thumbStrip.innerHTML = defaultThumbsHTML;
        // }
      } else {
        thumbStrip.innerHTML = defaultThumbsHTML;
        // Force first thumb active, remove any pre-selected state from Liquid
        media.refresh();
        media.thumbs.forEach((btn, i) => btn.classList.toggle('is-active', i === 0));
      }
      }

      // --- REBUILD MAIN MEDIA ---
      mainMediaWrap.innerHTML = '';
      if (images && images.length) {
        images.forEach((img, i) => {
          const div = document.createElement('div');
          div.className       = 'pdp-media-item' + (i === 0 ? ' is-active' : '');
          div.dataset.mediaId   = 'meta_' + i;
          div.dataset.mediaType = 'image';
          div.dataset.index     = String(i);
          div.innerHTML = `<button class="pdp-media-item__trigger" type="button" aria-label="Enlarge image" data-open-overlay="${i}"><img src="${img.src}" srcset="${img.src_600} 600w, ${img.src_900} 900w, ${img.src_1200} 1200w, ${img.src} 1400w" sizes="(max-width: 768px) 100vw, 60vw" alt="${img.alt || ''}" loading="lazy" class="pdp-media-item__img" width="${img.width || 1400}" height="${img.height || 1400}"><span class="pdp-media-item__zoom-hint"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg></span></button>`;
          mainMediaWrap.appendChild(div);
        });
      } else {
        defaultMediaItemsHTML.forEach((html, i) => {
          const div = document.createElement('div');
          div.className       = 'pdp-media-item' + (i === 0 ? ' is-active' : '');
          div.dataset.mediaId   = String(productData.media[i]?.id ?? i);
          div.dataset.mediaType = productData.media[i]?.media_type ?? 'image';
          div.dataset.index     = String(i);
          div.innerHTML = html;
          mainMediaWrap.appendChild(div);
        });
      }

      // --- REFRESH LIVE REFS ---
      media.refresh();

      // --- RE-OBSERVE scroll-spy ---
      media.items.forEach(item => scrollSpyObserver.observe(item));

      // --- REBUILD OVERLAY ---
      rebuildOverlaySlides(images && images.length ? images : null);

      // --- RESET position ---
      // For feature images: always show index 0
      // For default fallback: find the index matching the variant's featured_media_id
      // let targetIndex = 0;
      // if (!images || !images.length) {
      //   // Find currently selected variant's featured_media_id
      //   const selectedOptions = [];
      //   qsa('.pdp-option', section).forEach(g => {
      //     const checked = qs('input[type="radio"]:checked', g);
      //     if (checked) selectedOptions.push(checked.value);
      //   });
      //   const currentVariant = productData.variants.find(v =>
      //     selectedOptions.every((opt, i) => v.options[i] === opt)
      //   );
      //   if (currentVariant && currentVariant.featured_media_id) {
      //     const fIdx = productData.media.findIndex(m => m.id == currentVariant.featured_media_id);
      //     if (fIdx >= 0) targetIndex = fIdx;
      //   }
      // }

      // activeThumbIndex = targetIndex;
      // highlightThumb(targetIndex);

      // if (isMobile()) {
      //   mainMediaWrap.style.cssText = 'display:flex;flex-direction:row;overflow-x:scroll;scroll-snap-type:x mandatory;scroll-behavior:smooth;gap:0;-ms-overflow-style:none;scrollbar-width:none;-webkit-overflow-scrolling:touch;position:relative;';
      //   mainMediaWrap.scrollTo({ left: (media.items[targetIndex]?.offsetLeft || 0), behavior: 'instant' });
      //   setupMobileCarousel();
      // } else {
      //   // Desktop: scroll page so the target media item is visible in viewport
      //   const targetItem = media.items[targetIndex];
      //   if (targetItem) {
      //     const headerH = getStickyHeaderHeight();
      //     const vpH     = window.innerHeight;
      //     const imgH    = targetItem.offsetHeight;
      //     const imgTop  = (() => { let t = 0, el = targetItem; while (el) { t += el.offsetTop; el = el.offsetParent; } return t; })();
      //     const availH  = vpH - headerH;
      //     const targetY = imgTop - headerH - Math.floor((availH - imgH) / 2);
      //     isScrollingToMedia = true;
      //     clearTimeout(scrollLockTimer);
      //     window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
      //     if ('onscrollend' in window) {
      //       window.addEventListener('scrollend', () => {
      //         scrollLockTimer = setTimeout(() => { isScrollingToMedia = false; }, 80);
      //       }, { once: true });
      //     } else {
      //       scrollLockTimer = setTimeout(() => { isScrollingToMedia = false; }, 800);
      //     }
      //   }
      // }
      activeThumbIndex = 0;
      highlightThumb(0);

      if (isMobile()) {
        mainMediaWrap.style.cssText = 'display:flex;flex-direction:row;overflow-x:scroll;scroll-snap-type:x mandatory;scroll-behavior:smooth;gap:0;-ms-overflow-style:none;scrollbar-width:none;-webkit-overflow-scrolling:touch;position:relative;';
        mainMediaWrap.scrollTo({ left: 0, behavior: 'instant' });
        setupMobileCarousel();
      }
    }

    function rebuildOverlaySlides(images) {
      if (!overlayStage) return;
      overlayStage.innerHTML = '';
      overlaySlides.length = 0;

      const sourceData = images
        ? images.map((img, idx) => ({
            media_type: 'image',
            full_src: img.full_src || img.src,
            preview_src: img.src,
            alt: img.alt || '',
            id: 'meta_' + idx
          }))
        : defaultOverlayData;

      sourceData.forEach((media, idx) => {
        const slide = document.createElement('div');
        slide.className = 'pdp-overlay__slide' + (idx === 0 ? ' is-active' : '');
        slide.dataset.index = idx;

        if (media.media_type === 'image') {
          const img = document.createElement('img');
          img.src = media.full_src || media.preview_src;
          img.alt = media.alt || '';
          img.draggable = false;
          slide.appendChild(img);
        } else {
          // video/model — re-clone from DOM
          const original = qs(`[data-media-id="${media.id}"] video, [data-media-id="${media.id}"] iframe`, section);
          if (original) {
            const clone = original.cloneNode(true);
            clone.style.cssText = 'max-width:90vw;max-height:80vh;';
            slide.appendChild(clone);
          } else {
            const img = document.createElement('img');
            img.src = media.preview_src;
            img.alt = media.alt || '';
            img.draggable = false;
            slide.appendChild(img);
          }
        }

        overlayStage.appendChild(slide);
        overlaySlides.push(slide);
      });

      currentOverlayIndex = 0;
    }

    /* ─────────────────────────────────────────────
      STICKY INFO COLUMN (Desktop)
      Pure CSS sticky — no JS scroll listener fighting
      the browser. If column is taller than viewport,
      we anchor it to bottom (so user scrolls to see
      the bottom content first), otherwise to top.
    ───────────────────────────────────────────── */
    let smartStickyLastScrollY = window.scrollY; // kept for API compat with other code

    function desktopStickyScroll() {
      // Intentionally empty — kept as no-op so existing
      // removeEventListener calls don't break.
      // All sticky behavior is now pure CSS.
    }

    function recalcStickyTop() {
      if (isMobile()) return;
      const infoCol = section.querySelector('.pdp-info-column');
      if (!infoCol) return;

      const headerH = getStickyHeaderHeight();
      const vpH     = window.innerHeight;
      const colH    = infoCol.offsetHeight;
      const availH  = vpH - headerH;

      // If column fits in viewport → stick to top under header
      // If column is taller → anchor to bottom so user can read it as they scroll
      if (colH <= availH) {
        infoCol.style.top = headerH + 'px';
        infoCol.style.bottom = 'auto';
      } else {
        // Column is taller than viewport — pin its bottom to viewport bottom
        // This way the column scrolls naturally with the page (sticky bottom)
        infoCol.style.top = (vpH - colH - 16) + 'px';
        infoCol.style.bottom = 'auto';
      }
    }

    function setupDesktop() {
      const infoCol = section.querySelector('.pdp-info-column');
      if (!infoCol) return;
      infoCol.style.position = 'sticky';
      recalcStickyTop();

      // Recalc only when content height could change — NOT on every scroll
      // (this is what was causing the vibration)
      const ro = new ResizeObserver(() => recalcStickyTop());
      ro.observe(infoCol);

      // Also recalc when accordions open/close inside info column
      qsa('details.pdp-accordion', infoCol).forEach(d => {
        d.addEventListener('toggle', () => requestAnimationFrame(recalcStickyTop));
      });
    }

    /* ─────────────────────────────────────────────
       APPLY MODE
    ───────────────────────────────────────────── */
    function applyMode(mode) {
      if (mode === 'mobile') {
        teardownDesktop();
        setupMobileCarousel();
        const infoCol = section.querySelector('.pdp-info-column');
        if (infoCol) { infoCol.style.position = 'static'; infoCol.style.top = ''; }
      } else {
        teardownMobile();
        setupDesktop();
      }
    }

    applyMode(currentMode);

    /* ─────────────────────────────────────────────
       RESIZE
    ───────────────────────────────────────────── */
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const newMode = isMobile() ? 'mobile' : 'desktop';
        if (newMode !== currentMode) {
          currentMode = newMode;
          applyMode(newMode);
        } else if (newMode === 'desktop') {
          const infoCol = section.querySelector('.pdp-info-column');
          if (infoCol) {
            const headerH = getStickyHeaderHeight();
            smartStickyCurrentTop  = headerH;
            smartStickyLastScrollY = window.scrollY;
            infoCol.style.top = headerH + 'px';
          }
        }
      }, 150);
    });

    /* ─────────────────────────────────────────────
       BUILD OVERLAY SLIDES
       Uses feature images if Liquid rendered them,
       otherwise falls back to product default media.
    ───────────────────────────────────────────── */
    if (overlayStage) {
      // Detect if Liquid rendered feature images (first item has data-media-id starting with "meta_")
      const firstItem = media.items[0];
      const renderedFeature = firstItem && String(firstItem.dataset.mediaId || '').startsWith('meta_');

      if (renderedFeature) {
        // Build overlay from the feature images already in the DOM
        media.items.forEach((item, idx) => {
          const domImg = item.querySelector('img.pdp-media-item__img');
          const slide = document.createElement('div');
          slide.className = 'pdp-overlay__slide' + (idx === 0 ? ' is-active' : '');
          slide.dataset.index = idx;
          const img = document.createElement('img');
          // Grab the largest srcset entry (1400w) or fall back to src
          let bestSrc = domImg ? domImg.src : '';
          if (domImg && domImg.srcset) {
            const parts = domImg.srcset.split(',').map(s => s.trim().split(' '));
            const largest = parts.reduce((a, b) => (parseInt(b[1]) > parseInt(a[1]) ? b : a), parts[0]);
            if (largest && largest[0]) bestSrc = largest[0];
          }
          img.src = bestSrc;
          img.alt = domImg ? domImg.alt : '';
          img.draggable = false;
          slide.appendChild(img);
          overlayStage.appendChild(slide);
          overlaySlides.push(slide);
        });
      } else {
        // Default: build from productData.media
        productData.media.forEach((m, idx) => {
          const slide = document.createElement('div');
          slide.className = 'pdp-overlay__slide' + (idx === 0 ? ' is-active' : '');
          slide.dataset.index = idx;

          if (m.media_type === 'image') {
            const img = document.createElement('img');
            img.src = m.full_src || m.preview_src;
            img.alt = m.alt || '';
            img.draggable = false;
            slide.appendChild(img);
          } else if (m.media_type === 'video') {
            const original = qs(`[data-media-id="${m.id}"] video`, section);
            if (original) {
              const vid = original.cloneNode(true);
              vid.controls = true;
              vid.style.cssText = 'max-width:90vw;max-height:80vh;';
              slide.appendChild(vid);
            }
          } else if (m.media_type === 'external_video') {
            const original = qs(`[data-media-id="${m.id}"] iframe`, section);
            if (original) {
              const ifr = original.cloneNode(true);
              ifr.style.cssText = 'width:80vw;height:60vh;max-width:90vw;';
              slide.appendChild(ifr);
            }
          } else {
            const img = document.createElement('img');
            img.src = m.preview_src;
            img.alt = m.alt || '';
            img.draggable = false;
            slide.appendChild(img);
          }

          overlayStage.appendChild(slide);
          overlaySlides.push(slide);
        });
      }
    }

    /* ─────────────────────────────────────────────
       DESKTOP SCROLL-SPY
       Locked out while a programmatic scroll is running
    ───────────────────────────────────────────── */
    const scrollSpyObserver = new IntersectionObserver((entries) => {
      if (isMobile() || isScrollingToMedia) return;
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const idx = parseInt(entry.target.dataset.index, 10);
          highlightThumb(idx);
        }
      });
    }, { root: null, rootMargin: '-5% 0px -5% 0px', threshold: 0.4 });
    mediaItems.forEach(item => scrollSpyObserver.observe(item));

    /* Only updates the visual highlight — does NOT scroll */
    function highlightThumb(index) {
      activeThumbIndex = index;
      media.thumbs.forEach((btn, i) => btn.classList.toggle('is-active', i === index));
      media.items.forEach((item, i) => item.classList.toggle('is-active', i === index));
      const activeThumb = media.thumbs[index];
      if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    /* ─────────────────────────────────────────────
       THUMBNAIL CLICK → INSTANT JUMP (no smooth scroll fight)
    ───────────────────────────────────────────── */
    function getAbsoluteOffsetTop(el) {
      let top = 0;
      while (el) { top += el.offsetTop; el = el.offsetParent; }
      return top;
    }

    function scrollMediaIntoView(index) {
      const target = media.items[index];
      if (!target) return;

      // Lock scroll-spy so it doesn't fight while we scroll
      isScrollingToMedia = true;
      clearTimeout(scrollLockTimer);

      const headerH    = getStickyHeaderHeight();
      const vpH        = window.innerHeight;
      const imgH       = target.offsetHeight;
      const imgTop     = getAbsoluteOffsetTop(target);
      const availH     = vpH - headerH;

      let targetScrollY;
      if (imgH >= availH) {
        targetScrollY = imgTop - headerH - 8;
      } else {
        targetScrollY = imgTop - headerH - Math.floor((availH - imgH) / 2);
      }

      const finalY = Math.max(0, targetScrollY);

      // Unlock: use scrollend if supported, else fall back to scroll-idle detection
      function unlock() {
        clearTimeout(scrollLockTimer);
        scrollLockTimer = setTimeout(() => { isScrollingToMedia = false; }, 80);
      }

      if ('onscrollend' in window) {
        // Modern browsers — fires exactly when scroll animation finishes
        window.addEventListener('scrollend', unlock, { once: true });
      } else {
        // Fallback — detect scroll idle via repeated scroll event
        let idleTimer;
        function onScrollIdle() {
          clearTimeout(idleTimer);
          idleTimer = setTimeout(() => {
            window.removeEventListener('scroll', onScrollIdle);
            unlock();
          }, 120);
        }
        window.addEventListener('scroll', onScrollIdle, { passive: true });
        // Safety net in case scroll never fires (already at position)
        scrollLockTimer = setTimeout(() => {
          window.removeEventListener('scroll', onScrollIdle);
          isScrollingToMedia = false;
        }, 800);
      }

      window.scrollTo({ top: finalY, behavior: 'smooth' });
    }

    // Use event delegation on thumbStrip so it works after DOM rebuilds
    if (thumbStrip) {
      thumbStrip.addEventListener('click', (e) => {
        if (isMobile()) return;
        const btn = e.target.closest('.pdp-thumb');
        if (!btn) return;
        const index = parseInt(btn.dataset.index, 10);
        if (!isNaN(index)) {
          highlightThumb(index);
          scrollMediaIntoView(index);
        }
      });
    }

    /* ─────────────────────────────────────────────
       OVERLAY OPEN / CLOSE / NAVIGATE
    ───────────────────────────────────────────── */
    const slideState = productData.media.map(() => ({ scale: 1, tx: 0, ty: 0 }));
    const MIN_SCALE = 1, MAX_SCALE = 5;

    function getActiveImg() {
      const slide = overlaySlides[currentOverlayIndex];
      return slide ? slide.querySelector('img') : null;
    }

    function applyTransform(index, animate = false) {
      const slide = overlaySlides[index];
      if (!slide) return;
      const img = slide.querySelector('img');
      if (!img) return;
      const { scale, tx, ty } = slideState[index];
      img.style.transition = animate ? 'transform 0.25s ease' : 'none';
      img.style.transform  = `translate(${tx}px, ${ty}px) scale(${scale})`;
      img.style.cursor     = scale > 1 ? 'grab' : 'default';
    }

    function resetTransform(index, animate = true) {
      slideState[index] = { scale: 1, tx: 0, ty: 0 };
      applyTransform(index, animate);
    }

    function clampPan(index) {
      const slide = overlaySlides[index];
      if (!slide) return;
      const img = slide.querySelector('img');
      if (!img) return;
      const { scale } = slideState[index];
      if (scale <= 1) { slideState[index].tx = 0; slideState[index].ty = 0; return; }
      const vw = overlayStage.clientWidth;
      const vh = overlayStage.clientHeight;
      const iw = img.naturalWidth  || img.offsetWidth;
      const ih = img.naturalHeight || img.offsetHeight;
      const rendW = Math.min(iw, vw) * scale;
      const rendH = Math.min(ih, vh) * scale;
      const maxX = Math.max(0, (rendW - vw) / 2);
      const maxY = Math.max(0, (rendH - vh) / 2);
      slideState[index].tx = Math.max(-maxX, Math.min(maxX, slideState[index].tx));
      slideState[index].ty = Math.max(-maxY, Math.min(maxY, slideState[index].ty));
    }

    function openOverlay(index) {
      if (!overlayEl) return;
      overlayEl.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      goToSlide(index);
    }

    function closeOverlay() {
      if (!overlayEl) return;
      overlayEl.setAttribute('hidden', '');
      document.body.style.overflow = '';
      overlaySlides.forEach((_, i) => {
        const vid = overlaySlides[i].querySelector('video');
        if (vid) vid.pause();
        resetTransform(i, false);
      });
    }

    function goToSlide(index) {
      const total = overlaySlides.length;
      if (total === 0) return;
      index = ((index % total) + total) % total;
      resetTransform(currentOverlayIndex, false);
      resetTransform(index, false);
      overlaySlides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        const vid = slide.querySelector('video');
        if (vid && i !== index) vid.pause();
      });
      currentOverlayIndex = index;
      applyTransform(index, false);
    }

    section.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-open-overlay]');
      if (trigger) {
        const idx = parseInt(trigger.dataset.openOverlay, 10);
        openOverlay(isNaN(idx) ? 0 : idx);
      }
    });

    // Use event delegation so it works after DOM rebuilds
    if (isMobile() && mainMediaWrap) {
      mainMediaWrap.addEventListener('click', (e) => {
        if (e.target.closest('[data-open-overlay]')) return;
        const item = e.target.closest('.pdp-media-item');
        if (!item) return;
        const idx = parseInt(item.dataset.index, 10);
        if (!isNaN(idx)) openOverlay(idx);
      });
    }

    if (overlayClose) overlayClose.addEventListener('click', closeOverlay);
    if (overlayPrev)  overlayPrev.addEventListener('click', () => goToSlide(currentOverlayIndex - 1));
    if (overlayNext)  overlayNext.addEventListener('click', () => goToSlide(currentOverlayIndex + 1));

    document.addEventListener('keydown', (e) => {
      if (!overlayEl || overlayEl.hasAttribute('hidden')) return;
      if (e.key === 'Escape')           closeOverlay();
      if (e.key === 'ArrowLeft')        goToSlide(currentOverlayIndex - 1);
      if (e.key === 'ArrowRight')       goToSlide(currentOverlayIndex + 1);
      if (e.key === '+' || e.key === '=') zoomBy(0.25);
      if (e.key === '-')                zoomBy(-0.25);
      if (e.key === '0')                resetTransform(currentOverlayIndex, true);
    });

    /* ─────────────────────────────────────────────
       PAN & ZOOM ENGINE
    ───────────────────────────────────────────── */
    function zoomBy(delta, originX, originY) {
      const state = slideState[currentOverlayIndex];
      if (!getActiveImg()) return;
      const prevScale = state.scale;
      state.scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, state.scale + delta));
      if (originX !== undefined && state.scale !== prevScale) {
        const rect = overlayStage.getBoundingClientRect();
        const cx = (originX - rect.left) - rect.width / 2;
        const cy = (originY - rect.top) - rect.height / 2;
        const factor = state.scale / prevScale - 1;
        state.tx -= cx * factor;
        state.ty -= cy * factor;
      }
      if (state.scale === MIN_SCALE) { state.tx = 0; state.ty = 0; }
      else clampPan(currentOverlayIndex);
      applyTransform(currentOverlayIndex);
    }

    if (overlayStage) {
      overlayStage.addEventListener('wheel', (e) => {
        e.preventDefault();
        zoomBy(e.deltaY < 0 ? 0.2 : -0.2, e.clientX, e.clientY);
      }, { passive: false });

      overlayStage.addEventListener('dblclick', (e) => {
        const state = slideState[currentOverlayIndex];
        if (state.scale > 1) resetTransform(currentOverlayIndex, true);
        else zoomBy(1.5, e.clientX, e.clientY);
      });

      let isDragging = false, dragStartX = 0, dragStartY = 0;
      let dragStartTx = 0, dragStartTy = 0;
      let dragMoved = false, dragSwipeStartX = 0, dragStartScale = 1;

      overlayStage.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        isDragging      = true;
        dragMoved       = false;
        dragStartX      = e.clientX;
        dragStartY      = e.clientY;
        dragSwipeStartX = e.clientX;
        dragStartTx     = slideState[currentOverlayIndex].tx;
        dragStartTy     = slideState[currentOverlayIndex].ty;
        dragStartScale  = slideState[currentOverlayIndex].scale;
        const img = getActiveImg();
        if (img) img.style.cursor = dragStartScale > 1 ? 'grabbing' : 'default';
        e.preventDefault();
      });

      window.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const dx = e.clientX - dragStartX;
        const dy = e.clientY - dragStartY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) dragMoved = true;
        const state = slideState[currentOverlayIndex];
        if (state.scale > 1) {
          state.tx = dragStartTx + dx;
          state.ty = dragStartTy + dy;
          clampPan(currentOverlayIndex);
          applyTransform(currentOverlayIndex);
        }
      });

      window.addEventListener('mouseup', (e) => {
        if (!isDragging) return;
        isDragging = false;
        const img = getActiveImg();
        if (img) img.style.cursor = slideState[currentOverlayIndex].scale > 1 ? 'grab' : 'default';
        if (dragStartScale <= 1 && dragMoved) {
          const diff = dragSwipeStartX - e.clientX;
          if (Math.abs(diff) > 60) {
            diff > 0 ? goToSlide(currentOverlayIndex + 1) : goToSlide(currentOverlayIndex - 1);
          }
        }
      });

      overlayStage.addEventListener('dragstart', (e) => e.preventDefault());

      let touches = [], lastPinchDist = 0;
      let touchPanStart = { tx: 0, ty: 0 }, touchMidStart = { x: 0, y: 0 };
      let touchSwipeStartX = 0, touchMoved = false, touchStartScale = 1;

      function getTouchDist(t) {
        const dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
      function getTouchMid(t) {
        return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 };
      }

      overlayStage.addEventListener('touchstart', (e) => {
        touches = Array.from(e.touches);
        touchMoved = false;
        const state = slideState[currentOverlayIndex];
        touchStartScale = state.scale;
        if (touches.length === 1) {
          touchSwipeStartX = touches[0].clientX;
          touchPanStart = { tx: state.tx, ty: state.ty };
          touchMidStart = { x: touches[0].clientX, y: touches[0].clientY };
        } else if (touches.length === 2) {
          lastPinchDist = getTouchDist(touches);
          touchPanStart = { tx: state.tx, ty: state.ty };
          touchMidStart = getTouchMid(touches);
        }
      }, { passive: true });

      overlayStage.addEventListener('touchmove', (e) => {
        e.preventDefault();
        touches = Array.from(e.touches);
        const state = slideState[currentOverlayIndex];
        touchMoved = true;
        if (touches.length === 2) {
          const dist = getTouchDist(touches);
          const mid  = getTouchMid(touches);
          const pinchDelta = (dist - lastPinchDist) / 80;
          lastPinchDist = dist;
          const prevScale = state.scale;
          state.scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, state.scale + pinchDelta));
          if (state.scale !== prevScale) {
            const rect = overlayStage.getBoundingClientRect();
            const cx = (mid.x - rect.left) - rect.width / 2;
            const cy = (mid.y - rect.top) - rect.height / 2;
            const factor = state.scale / prevScale - 1;
            state.tx -= cx * factor;
            state.ty -= cy * factor;
          }
          state.tx += mid.x - touchMidStart.x;
          state.ty += mid.y - touchMidStart.y;
          touchMidStart = mid;
          clampPan(currentOverlayIndex);
          applyTransform(currentOverlayIndex);
        } else if (touches.length === 1 && state.scale > 1) {
          state.tx = touchPanStart.tx + (touches[0].clientX - touchSwipeStartX);
          state.ty = touchPanStart.ty + (touches[0].clientY - touchMidStart.y);
          clampPan(currentOverlayIndex);
          applyTransform(currentOverlayIndex);
        }
      }, { passive: false });

      overlayStage.addEventListener('touchend', (e) => {
        const state = slideState[currentOverlayIndex];
        if (touchStartScale <= 1 && e.changedTouches.length === 1 && touchMoved) {
          const diff = touchSwipeStartX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 60) {
            diff > 0 ? goToSlide(currentOverlayIndex + 1) : goToSlide(currentOverlayIndex - 1);
          }
        }
        if (state.scale <= 1) resetTransform(currentOverlayIndex, true);
        touches = Array.from(e.touches);
      }, { passive: true });
    }

    /* ─────────────────────────────────────────────
       VARIANT PICKER
    ───────────────────────────────────────────── */
    const priceBlock = $(`pdp-price-${sid}`);
    const skuBlock   = $(`pdp-sku-${sid}`);

    // Localized button labels — sourced from the section's data-* attributes so the JS
    // uses the exact same translations (and active locale) as the server-rendered button.
    const BTN_LABELS = {
      add:         section.dataset.atcLabel         || 'Add to cart',
      soldOut:     section.dataset.soldoutLabel     || 'Sold out',
      preorder:    section.dataset.preorderLabel    || 'Pre-order',
      unavailable: section.dataset.unavailableLabel || 'Unavailable'
    };

    // Pre-order = inventory is tracked, stock is depleted (<= 0), but the merchant
    // allows overselling (policy 'continue'). Mirrors the Liquid condition used in
    // buy-buttons.liquid and the sticky bar so client + server agree.
    function isPreorderVariant(v) {
      return !!(v && v.inventory_management && v.inventory_quantity <= 0 && v.inventory_policy === 'continue');
    }

    // Every Add-to-Cart button tied to this product: the main buy button and the mobile
    // sticky bar (which lives outside the section, so it is looked up by its form id).
    function getAtcButtons() {
      const list = [];
      const main = qs('#featured_cart_btn button[type="submit"]', section)
                || qs('.pdp-block--buy button[type="submit"]', section)
                || qs('button[type="submit"]', section);
      if (main) list.push(main);
      const sticky = qs(`#mob-sticky-atc-pdp-form-${sid} button[type="submit"]`)
                  || qs('[data-sticky-atc] button[type="submit"]');
      if (sticky && !list.includes(sticky)) list.push(sticky);
      return list;
    }

    // Set a button's visible label without destroying any icon markup it may contain.
    // The buy-button renders its label as a bare text node (no <span>), so we replace
    // the text directly instead of looking for a child element that does not exist.
    function setButtonLabel(btn, label) {
      const iconWrap = btn.querySelector('.text-with-icon');
      if (iconWrap) {
        const textNode = [...iconWrap.childNodes].reverse().find(n => n.nodeType === 3 && n.textContent.trim());
        if (textNode) textNode.textContent = label;
        else iconWrap.appendChild(document.createTextNode(label));
      } else {
        btn.textContent = label;
      }
    }

    // Add/remove the "Pre-Order" line item property on the product form so the order is
    // tagged correctly. Matches the hidden input rendered by buy-buttons.liquid on load.
    function setPreorderProperty(on) {
      const formEl = $(`pdp-form-${sid}`);
      if (!formEl) return;
      let input = formEl.querySelector('input[name="properties[Status]"]');
      if (on) {
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[Status]';
          formEl.appendChild(input);
        }
        input.value = 'Pre-Order';
        input.disabled = false;
      } else if (input) {
        input.remove();
      }
    }

    // Single source of truth for the buy-button state given the active variant.
    function applyButtonState(variant) {
      let label, disabled, preorder = false;
      if (!variant) {
        label = BTN_LABELS.unavailable; disabled = true;
      } else if (variant.available === false) {
        label = BTN_LABELS.soldOut; disabled = true;
      } else if (isPreorderVariant(variant)) {
        label = BTN_LABELS.preorder; disabled = false; preorder = true;
      } else {
        label = BTN_LABELS.add; disabled = false;
      }
      getAtcButtons().forEach((btn) => {
        btn.disabled = disabled;
        setButtonLabel(btn, label);
        btn.classList.toggle('is-unavailable', disabled);
      });
      setPreorderProperty(preorder);
    }

    // Cross out the size pills that are sold out for the currently-selected color
    // (and any other selected options). Recomputed on load and on every change so
    // the strike always reflects the active color. Only pill groups (sizes) are
    // marked — colour swatches are left untouched.
    function markSoldOutSizes() {
      const groups = qsa('.pdp-option', section);
      const selected = groups.map((g) => {
        const checked = qs('input[type="radio"]:checked', g);
        return checked ? checked.value : null;
      });
      groups.forEach((g, optIdx) => {
        if (!qs('.pdp-pills', g)) return;
        qsa('input[type="radio"]', g).forEach((input) => {
          const candidate = selected.slice();
          candidate[optIdx] = input.value;
          const variant = productData.variants.find(v =>
            candidate.every((opt, i) => opt == null || v.options[i] === opt));
          const soldOut = !variant || variant.available === false;
          input.closest('.pdp-pill')?.classList.toggle('is-sold-out', soldOut);
        });
      });
    }

    section.addEventListener('change', (e) => {
      const input = e.target;
      if (!input.classList.contains('pdp-swatch__input') && !input.classList.contains('pdp-pill__input')) return;

      const optionIndex = parseInt(input.dataset.optionIndex, 10);
      const valLabel = $(`pdp-opt-val-${optionIndex}-${sid}`);
      if (valLabel) valLabel.textContent = input.value;

      const group = input.closest('.pdp-swatches, .pdp-pills');
      if (group) {
        qsa('.pdp-swatch, .pdp-pill', group).forEach(el => el.classList.remove('is-active'));
        input.closest('.pdp-swatch, .pdp-pill')?.classList.add('is-active');
      }

      // Refresh which sizes are struck out for the (possibly new) colour selection
      markSoldOutSizes();

      const selectedOptions = [];
      qsa('.pdp-option', section).forEach(g => {
        const checked = qs('input[type="radio"]:checked', g);
        if (checked) selectedOptions.push(checked.value);
      });

      const matchedVariant = productData.variants.find(v => selectedOptions.every((opt, i) => v.options[i] === opt));
      if (!matchedVariant) { applyButtonState(null); return; }

      // Swap media only when the color option changed
      const colorIdx = getColorOptionIndex();
      if (colorIdx >= 0 && input.dataset.optionIndex == colorIdx) {
        swapMediaForColor(input.value);
      }

      if (variantIdInput) variantIdInput.value = matchedVariant.id;

      const formEl = document.getElementById(`pdp-form-${sid}`);
      if (formEl) {
        const formVariantInput = qs('[name="id"]', formEl);
        if (formVariantInput) formVariantInput.value = matchedVariant.id;
      }

      applyButtonState(matchedVariant);

      if (priceBlock) {
        const priceDiv = qs('.pdp-price', priceBlock);
        if (priceDiv) {
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            const pct = Math.round((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price * 100);
            priceDiv.innerHTML = `<span class="pdp-price__compare">${money(matchedVariant.compare_at_price)}</span><span class="pdp-price__sale">${money(matchedVariant.price)}</span><span class="pdp-price__badge">-${pct}%</span>`;
          } else {
            priceDiv.innerHTML = `<span class="pdp-price__current">${money(matchedVariant.price)}</span>`;
          }
        }
      }

      const skuVal = $(`pdp-sku-val-${sid}`);
      if (skuVal && matchedVariant.sku) {
        skuVal.textContent = matchedVariant.sku;
        if (skuBlock) skuBlock.style.display = '';
      } else if (skuBlock) {
        skuBlock.style.display = 'none';
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', matchedVariant.id);
      window.history.replaceState({}, '', url.toString());

      section.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: matchedVariant, sectionId: sid } }));
    });

    // Sync the buttons (main + mobile sticky) and pre-order property to the initial
    // selection on load. Covers ?variant= deep links and keeps the sticky bar in step.
    // If the current selection somehow maps to no variant, leave the server render as-is.
    (function syncInitialButtonState() {
      const selected = [];
      qsa('.pdp-option', section).forEach((g) => {
        const checked = qs('input[type="radio"]:checked', g);
        if (checked) selected.push(checked.value);
      });
      const variant = selected.length
        ? productData.variants.find(v => selected.every((opt, i) => v.options[i] === opt))
        : productData.variants[0];
      if (variant) applyButtonState(variant);
      markSoldOutSizes();
    })();

    /* ─────────────────────────────────────────────
       QUANTITY BUTTONS
    ───────────────────────────────────────────── */
    section.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const input = qs('.pdp-qty__input', btn.closest('.pdp-qty'));
      if (!input) return;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyChange, 10));
    });

    /* ─────────────────────────────────────────────
       THEME EDITOR RE-RENDER
    ───────────────────────────────────────────── */
    document.addEventListener('shopify:section:load', (e) => {
      if (e.detail.sectionId === sid) {
        const reloaded = qs(`[data-section-id="${sid}"]`);
        if (reloaded) initPDP(reloaded);
      }
    });

  const accordionNav = qs('.pdp-accordion-nav', section);
  if (accordionNav) {

  function findCollapsibleByHeading(headingText) {
    if (!headingText) return null;
    const target = headingText.trim().toLowerCase();
    const allDetails = qsa('details.pdp-accordion', section);
    return allDetails.find(d => {
      const summarySpan = d.querySelector('.pdp-accordion__trigger > span:first-child');
      const text = (summarySpan ? summarySpan.textContent : '').trim().toLowerCase();
      return text === target;
    }) || null;
  }

  function getAbsTop(el) {
    let top = 0;
    while (el) { top += el.offsetTop; el = el.offsetParent; }
    return top;
  }

  // Manual smooth scroll that recalculates target each frame.
  // This is immune to mid-scroll layout shifts (accordion opening, images loading, etc).
  function smoothScrollToEl(el, onDone) {
    if (!el) { onDone && onDone(); return; }

    isScrollingToMedia = true;          // lock smart-sticky + scroll-spy
    clearTimeout(scrollLockTimer);

    const headerH = getStickyHeaderHeight();
    const startY  = window.scrollY;
    const startT  = performance.now();
    const DURATION = 500;               // ms — feels snappy but smooth
    let lastTargetY = -1;
    let rafId = null;

    function ease(t) { return t < 0.5 ? 2*t*t : 1 - Math.pow(-2*t+2, 2)/2; }

    function step(now) {
      const elapsed = now - startT;
      const t = Math.min(1, elapsed / DURATION);
      const k = ease(t);

      // Recalculate target Y every frame — handles layout shifts gracefully
      const targetY = Math.max(0, getAbsTop(el) - headerH - 16);
      lastTargetY = targetY;

      const y = startY + (targetY - startY) * k;
      window.scrollTo(0, y);

      if (t < 1) {
        rafId = requestAnimationFrame(step);
      } else {
        // Snap to final target one more time in case of late layout shift
        window.scrollTo(0, lastTargetY);
        // Release lock after a short settle delay
        scrollLockTimer = setTimeout(() => {
          isScrollingToMedia = false;
          smartStickyLastScrollY = window.scrollY;  // resync sticky reference
          onDone && onDone();
        }, 60);
      }
    }

    rafId = requestAnimationFrame(step);

    // Safety: cancel if user starts manually scrolling/touching
    function userInterrupt() {
      if (rafId) cancelAnimationFrame(rafId);
      isScrollingToMedia = false;
      smartStickyLastScrollY = window.scrollY;
      window.removeEventListener('wheel', userInterrupt);
      window.removeEventListener('touchstart', userInterrupt);
      window.removeEventListener('keydown', onKeyInterrupt);
    }
    function onKeyInterrupt(e) {
      if (['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(e.key)) {
        userInterrupt();
      }
    }
    window.addEventListener('wheel', userInterrupt, { passive: true, once: true });
    window.addEventListener('touchstart', userInterrupt, { passive: true, once: true });
    window.addEventListener('keydown', onKeyInterrupt, { once: true });
  }

  function openDetails(detailsEl) {
    if (!detailsEl) return;
    if (!detailsEl.open) {
      detailsEl.open = true;
      detailsEl.dispatchEvent(new Event('toggle'));
    }
  }

  accordionNav.addEventListener('click', (e) => {
    const tab = e.target.closest('.pdp-accordion-nav__tab');
    if (!tab) return;

    const isMore   = tab.dataset.isMore === 'true';
    const targetTx = tab.dataset.target || '';

    // ── "MORE" button: just scroll to the .pdp-collapsible section.
    //    Do NOT open any tab inside it.
    if (isMore) {
      const collapsibleSection =
        qs('.pdp-collapsible', section) ||
        qs('.pdp-collapsible--media', section);
      if (collapsibleSection) {
        requestAnimationFrame(() => smoothScrollToEl(collapsibleSection));
      }
      return;
    }

    // ── Regular tab: open matching accordion, then scroll to it
    const matched = findCollapsibleByHeading(targetTx);
    if (matched) openDetails(matched);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (matched) smoothScrollToEl(matched);
      });
    });
  });
  }

  } // end initPDP

})();

// For Sticky add to cart new template js
(function () {
  if (window.innerWidth >= 768) return;

  var stickyBar = document.querySelector('[data-sticky-atc]');

  if (!stickyBar) {
    console.warn('[MOB-ATC] sticky bar not found');
    return;
  }

  function initObserver() {
    var target = document.getElementById('featured_cart_btn');

    if (!target) {
      console.warn('[MOB-ATC] #featured_cart_btn not found, retrying...');
      setTimeout(initObserver, 300);
      return;
    }

    console.log('[MOB-ATC] observing:', target);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('mob-sticky-atc--visible');
        } else {
          stickyBar.classList.add('mob-sticky-atc--visible');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

})();

// For collapsible accordian js
document.addEventListener('DOMContentLoaded', function () {

  function initPdpAccordions() {

    const accordions = document.querySelectorAll('.js-accordion');

    accordions.forEach((accordion) => {

      /* prevent duplicate listeners */
      if (accordion.dataset.init == 'true') return;

      accordion.dataset.init = 'true';

      const content = accordion.querySelector('.js-readmore-content');
      const btn = accordion.querySelector('.pdp-readmore-btn');

      /* =========================
         ONE OPEN AT A TIME
      ========================== */

      accordion.addEventListener('toggle', function () {

        if (accordion.open) {

          accordions.forEach((other) => {

            if (other !== accordion) {
              other.removeAttribute('open');
            }

          });

        }

      });

      /* =========================
         SHOW MORE / LESS
      ========================== */

      if (!content || !btn) return;

      function checkContentHeight() {

        const collapsedHeight = parseInt(
          getComputedStyle(content).getPropertyValue('--collapsed-height')
        );

        /* reset */
        btn.classList.remove('is-hidden');
        content.classList.remove('has-fade');

        if (content.scrollHeight <= collapsedHeight + 20) {

          btn.classList.add('is-hidden');

        } else {

          content.classList.add('has-fade');

        }

      }

      /* initial */
      checkContentHeight();

      /* resize recalc */
      window.addEventListener('resize', checkContentHeight);

      btn.addEventListener('click', function () {

        content.classList.toggle('is-expanded');

        if (content.classList.contains('is-expanded')) {

          btn.textContent = 'Show Less';

        } else {

          btn.textContent = 'Show More';

        }

      });

    });

  }

  initPdpAccordions();

});

// Swatch "+N" show-more (PDP) — saare swatches DOM mein hi rehte hain,
// sirf 3 ke baad wale hidden; +N click pe reveal. Variant/image-swap untouched.
(function () {
  function expandIfActiveHidden(root) {
    (root || document).querySelectorAll('.pdp-swatches--collapsible').forEach(function (wrap) {
      if (wrap.querySelector('.pdp-swatch--extra.is-active')) {
        wrap.classList.add('is-expanded');
      }
    });
  }

  // Delegated — DOM rebuild / section reload ke baad bhi chalta hai
  document.addEventListener('click', function (e) {
    var moreBtn = e.target.closest('.pdp-swatch-more');
    if (!moreBtn) return;
    e.preventDefault();
    var wrap = moreBtn.closest('.pdp-swatches');
    if (wrap) wrap.classList.add('is-expanded');
  });

  document.addEventListener('DOMContentLoaded', function () { expandIfActiveHidden(document); });
  document.addEventListener('shopify:section:load', function () { expandIfActiveHidden(document); });
})();